import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Loader2 } from "lucide-react";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import Dashboard from "./pages/Dashboard";
import ExercisesPage from "./pages/ExercisesPage";
import ExerciseDetailPage from "./pages/ExerciseDetailPage";
import CoherenceCardiaquePage from "./pages/CoherenceCardiaquePage";
import CrisisJournalPage from "./pages/CrisisJournalPage";
import AudioLibraryPage from "./pages/AudioLibraryPage";
import AdminDashboard from "./pages/AdminDashboard";
import BoucliersPage from "./pages/BoucliersPage";
import AccusationRetourneePage from "./pages/AccusationRetourneePage";
import SosParentPage from "./pages/SosParentPage";
import PourLeMomentPage from "./pages/PourLeMomentPage";
import TestsPage from "./pages/TestsPage";
import OrientationPage from "./pages/OrientationPage";
import EngagementPage from "./pages/EngagementPage";
import EmdrPage from "./pages/EmdrPage";
import MentionsLegales from "./pages/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import CGU from "./pages/CGU";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import { CookieBanner } from "./components/CookieBanner";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-[#6B8576]" /></div>;
  if (!user) return <Navigate to="/login" />;
  return children;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-[#6B8576]" /></div>;
  if (user) return <Navigate to="/dashboard" />;
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<PublicRoute><LandingPage /></PublicRoute>} />
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/exercises" element={<ProtectedRoute><ExercisesPage /></ProtectedRoute>} />
          <Route path="/exercises/:exerciseId" element={<ProtectedRoute><ExerciseDetailPage /></ProtectedRoute>} />
          <Route path="/coherence" element={<ProtectedRoute><CoherenceCardiaquePage /></ProtectedRoute>} />
          <Route path="/crisis" element={<ProtectedRoute><CrisisJournalPage /></ProtectedRoute>} />
          <Route path="/audio" element={<ProtectedRoute><AudioLibraryPage /></ProtectedRoute>} />
          <Route path="/boucliers" element={<ProtectedRoute><BoucliersPage /></ProtectedRoute>} />
          <Route path="/accusation-retournee" element={<ProtectedRoute><AccusationRetourneePage /></ProtectedRoute>} />
          <Route path="/sos-parent" element={<ProtectedRoute><SosParentPage /></ProtectedRoute>} />
          <Route path="/pour-le-moment" element={<ProtectedRoute><PourLeMomentPage /></ProtectedRoute>} />
          <Route path="/tests" element={<ProtectedRoute><TestsPage /></ProtectedRoute>} />
          <Route path="/orientation" element={<ProtectedRoute><OrientationPage /></ProtectedRoute>} />
          <Route path="/engagement" element={<ProtectedRoute><EngagementPage /></ProtectedRoute>} />
          <Route path="/sos-yeux" element={<ProtectedRoute><EmdrPage /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/cgu" element={<CGU />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <CookieBanner />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
